import * as React from 'react';
import { useRef, useEffect } from 'react';

const PointSectionComponent = ({ children , "aria-checked": ariaChecked , ...props })=>{
    const ref = useRef(null);
    const didMountRef = useRef(false);
    useEffect(()=>{
        if (ref.current && ariaChecked && didMountRef.current) {
            ref.current.focus();
        }
    }, [
        ariaChecked
    ]);
    useEffect(()=>{
        if (!didMountRef.current) {
            didMountRef.current = true;
        }
    }, []);
    return /*#__PURE__*/ React.createElement("div", {
        ref: ref,
        "aria-checked": ariaChecked,
        ...props
    }, children);
};

export { PointSectionComponent };
